import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { siteConfigStore } from '~/modules/stores/siteConfigStore';
import { isClient } from '~/modules/utilities/cross_env_utils';
import { JAPANESE_LANGUAGE_CODE } from '~/modules/utilities/language_utils';

const JP_LOCALE = 'jp';

// Client-side only — for server-side URL building use `isPathBasedJP(req)`.
export function getCurrentLocalePrefix(): string {
    if (!siteConfigStore.getState().isAgentExchange) {
        return '';
    }
    if (!isClient) {
        return '';
    }
    const { pathname } = window.location;
    if (pathname === `/${JP_LOCALE}` || pathname.startsWith(`/${JP_LOCALE}/`)) {
        return `/${JP_LOCALE}`;
    }
    return '';
}

export function withLocalePrefix(path: string): string {
    if (siteConfigStore.getState().isAgentExchange && getUserLanguage() === JAPANESE_LANGUAGE_CODE) {
        return `/jp${path}`;
    }
    return path;
}
